const traffic = {
  't-global-config': 'Global Config',
  't-save-config': 'Save Config',
  't-time-window': 'Time Window',
  't-time-window-seconds': 'Time Window (s)',
  't-max-download-count': 'Max Downloads',
  't-max-retry-count': 'Max Retries',
  't-global-config-hint': 'Partners without individual config will use this global default. Applies to mpush devices only.',
  't-circuit-breaker-strategy': 'Circuit Breaker Strategy',
  't-circuit-breaker-enabled': 'This Partner will apply an independent circuit breaker strategy',
  't-circuit-breaker-disabled': 'Use global config when disabled',
  't-config-params': 'Config Params',
  't-time-window-label': 'Time Window',
  't-max-download-label': 'Max Download',
  't-max-retry-label': 'Max Retry',
  't-ban-behavior-title': 'Ban Behavior Description',
  't-ban-behavior-desc': 'Retries exhausted → Device enters banned state → All download requests in current window return {0}, device stops downloading',
  't-download-settings': 'Download Settings',
  't-traffic-mgmt': 'Traffic Mgmt',
  "t-error-download-settings": "Rate Limiter",
  't-add-config': 'Add Config',
  't-edit-config': 'Edit Config',
  't-status-enabled': 'Enabled',
  't-status-disabled': 'Disabled',
  't-select-partner': 'Please select a Partner',
  't-select-partner-required': 'Please select a Partner',
  't-fill-time-window': 'Please fill in the time window',
  't-save-success': 'Saved successfully',
  't-save-failed': 'Save failed',
  't-update-success': 'Updated successfully',
  't-update-failed': 'Update failed',
  't-add-success': 'Added successfully',
  't-add-failed': 'Add failed',
  't-load-failed': 'Data load failed',
  't-second': 's',
  't-times': 'times',
  't-fill-max-download': 'Please fill in the max download count',
  't-fill-allowed-retry': 'Please fill in the allowed retry count',
  't-time-window-range-error': 'Time Window must be between 1 and 7200',
  't-max-download-range-error': 'Max Download must be between 5 and 200',
  't-allowed-retry-range-error': 'Allowed Retry must be between 1 and 20',
  't-traffic-overview': 'Traffic Overview',
  't-monthly-total-traffic': 'Monthly Total Traffic',
  't-compared-last-month': 'vs last month',
  't-partner-count': 'Partner Count',
  't-this-month-new': 'new this month',
  't-over-limit-partner': 'Over-limit Partners',
  't-need-attention': 'Needs attention',
  't-all-partner': 'All Partners',
  't-all-usage-rate': 'All Usage Rates',
  't-current-month-used-traffic': 'Used Traffic This Month',
  't-traffic-limit': 'Traffic Limit',
  't-usage-rate': 'Usage Rate',
  't-this-month-download-count': 'Downloads This Month',
  't-normal': 'Normal',
  't-about-to-exceed': 'Near Limit',
  't-exceeded': 'Exceeded',
  't-unlimited': 'Unlimited',
  't-unlimited-traffic': 'Unlimited Traffic',
  't-view-traffic-detail': 'View traffic details',
  't-download-records': 'Downloads This Month',
  't-file-name': 'File Name',
  't-file-size': 'File Size',
  't-usage-history': 'Data Usage History',
  't-data-usage-trend': 'Data Usage Trend',
  't-last-30-days-data-usage-trend': 'Last 30 days data usage trend',
  't-used-traffic': 'Used Traffic',
  't-last-12-months-traffic-trend': 'Traffic Trend in the Last 12 Months',
  't-month': 'Month',
  't-all-months': 'All Months',
  't-download-count': 'Download Count',
  't-quota-configuration': 'Traffic Limits',
  't-global-default-config': 'Global Default Configuration',
  't-global-default-traffic-limit': 'Global Default Traffic Limit',
  't-current-config': 'Current Configuration',
  't-quota-global-config-hint': 'Partners without individual traffic limit configuration will use this default value. Set to 0 for unlimited traffic.',
  't-partner-traffic-limit-config': 'Partner Traffic Limit Configuration',
  't-config-type': 'Config Type',
  't-use-global': 'Use Global',
  't-custom': 'Custom',
}

export default traffic
